/* drl-offer-options — kártyás variánsválasztó, egy vagy két tengelyen.

   EGY IGAZSÁG: a rejtett input[name="id"]. Minden felület — a kártya, a
   méretpirula, a tapadó sáv (drl-sticky-atc) és a Dawn saját választója —
   oda ír, és onnan olvas vissza.

   AMI 2026-08-27-ig ROSSZ VOLT, ÉS PÉNZBE KERÜLT

   A pirulasor a SAJÁT szülőjében (.drl-offers__pill-group) kereste a
   kártyákat, de azok a testvér .drl-offers dobozban vannak: a NodeList üres
   volt, tehát a méretváltás semmit nem írt át. A vevő 41-46-ot választott, a
   kosárba 35-40 ment, és mivel a két méret ÁRA azonos, semmi nem árulta el.
   Ezért a kártyákat innentől mindig a mérethez tartozó dobozból kérdezzük,
   és a visszairányt is megnyitjuk: ami az input[name="id"]-n változik —
   akár a tapadó sáv lapján —, azt a piruláknak és a kártyáknak követniük
   kell, különben a következő kártyakattintás visszaírja a régi méretet. */
(function () {
  function formInput(el) {
    var productEl = el.closest('product-info') || el.closest('.product');
    if (!productEl) return null;
    return productEl.querySelector('input[name="id"].product-variant-id') ||
           productEl.querySelector('input[name="id"]');
  }

  function writeVariant(el, variantId) {
    if (!variantId) return;
    var idInput = formInput(el);
    if (!idInput || idInput.value === String(variantId)) return;
    idInput.value = variantId;
    idInput.removeAttribute('disabled');
    idInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function markSelected(group, offer) {
    group.querySelectorAll('[data-drl-offer]').forEach(function (el) {
      var isMe = el === offer;
      el.classList.toggle('drl-offer--selected', isMe);
      el.setAttribute('aria-pressed', isMe ? 'true' : 'false');
    });
  }

  function selectOffer(offer) {
    var group = offer.closest('[data-drl-offers]');
    if (!group) return;
    markSelected(group, offer);
    writeVariant(offer, offer.getAttribute('data-variant-id'));
  }

  function initOffers(root) {
    (root || document).querySelectorAll('[data-drl-offer]').forEach(function (offer) {
      if (offer.dataset.drlBound) return;
      offer.dataset.drlBound = '1';
      offer.addEventListener('click', function (e) {
        e.preventDefault();
        selectOffer(offer);
      });
    });
  }

  // === MULTI-AXIS: pirulasor (méret) × kártyák (mennyiség) ===

  // A kártyák a pirulasor TESTVÉRÉBEN vannak, nem alatta. A közös doboz a
  // [data-drl-offers-scope]; a felfelé sétálás csak akkor kell, ha a jelölés
  // és a script egy pillanatra kicsúszna egymásból (téma-szerkesztő).
  function groupFor(pillRow) {
    var scope = pillRow.closest('[data-drl-offers-scope]');
    if (scope) {
      var inScope = scope.querySelector('[data-drl-offers]');
      if (inScope) return inScope;
    }
    var node = pillRow.parentElement;
    while (node) {
      var g = node.querySelector('[data-drl-offers]');
      if (g) return g;
      node = node.parentElement;
    }
    return null;
  }

  function paintCard(ctx, card, pillVal) {
    var cardVal = card.dataset.cardOptionValue;
    var matched = null;
    for (var i = 0; i < ctx.variants.length; i++) {
      var v = ctx.variants[i];
      if (ctx.pillAxis === 1 && v.option1 === pillVal && v.option2 === cardVal) { matched = v; break; }
      if (ctx.pillAxis === 2 && v.option2 === pillVal && v.option1 === cardVal) { matched = v; break; }
    }

    var soldOut = card.querySelector('[data-drl-sold-out]');
    // Nincs ilyen kombináció: a kártya nem maradhat a MÁSIK méret variánsán —
    // az pontosan a most javított hiba lenne, csak fordítva.
    if (!matched) {
      card.removeAttribute('data-variant-id');
      card.classList.add('drl-offer--unavailable');
      if (soldOut) soldOut.removeAttribute('hidden');
      return;
    }

    card.dataset.variantId = matched.id;

    var priceEl = card.querySelector('[data-drl-price]');
    if (priceEl) priceEl.textContent = matched.priceFormatted;

    var oldEl = card.querySelector('[data-drl-price-old]');
    if (oldEl) {
      if (matched.comparePriceFormatted) {
        oldEl.textContent = matched.comparePriceFormatted;
        oldEl.removeAttribute('hidden');
      } else {
        oldEl.setAttribute('hidden', '');
      }
    }

    var savEl = card.querySelector('[data-drl-savings]');
    if (savEl) {
      if (matched.savingsFormatted) {
        savEl.textContent = ctx.savingsFmt
          .replace('{savings}', matched.savingsFormatted)
          .replace('{price}', matched.priceFormatted)
          .replace('{compare_at}', matched.comparePriceFormatted);
        savEl.removeAttribute('hidden');
      } else {
        savEl.setAttribute('hidden', '');
      }
    }

    card.classList.toggle('drl-offer--unavailable', !matched.available);
    if (soldOut) {
      if (matched.available) soldOut.setAttribute('hidden', '');
      else soldOut.removeAttribute('hidden');
    }
  }

  // write=false: az input MÁR ezt mondja (visszairány), csak festünk. Írni
  // ilyenkor végtelen kört nyitna a change eseményen.
  function applyPill(ctx, pillVal, write) {
    ctx.pillRow.querySelectorAll('.drl-offer-pill').forEach(function (p) {
      var on = p.dataset.drlPillValue === pillVal;
      p.classList.toggle('drl-offer-pill--active', on);
      p.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var cards = ctx.group.querySelectorAll('[data-drl-offer][data-card-option-value]');
    cards.forEach(function (card) { paintCard(ctx, card, pillVal); });

    // Kit jelöljünk? Sorrendben: a mostani, ha kapható; az első kapható; a
    // mostani, ha legalább van hozzá variáns; az első, amihez van. A cél
    // egyetlen mondat: az űrlap SOHA ne maradjon a MÁSIK pirula variánsán.
    // Egy elfogyott kombináció is a saját variánsát viszi — az „Elfogyott"
    // gomb helyes válasz, a néma rossz méret nem.
    var cur = ctx.group.querySelector('.drl-offer--selected');
    var curOk = cur && cur.getAttribute('data-variant-id');
    var firstOk = ctx.group.querySelector('[data-drl-offer]:not(.drl-offer--unavailable)[data-variant-id]');
    var pick = null;
    if (curOk && !cur.classList.contains('drl-offer--unavailable')) pick = cur;
    else pick = firstOk || (curOk ? cur : null) || ctx.group.querySelector('[data-drl-offer][data-variant-id]');
    if (!pick) return;
    markSelected(ctx.group, pick);
    if (write) writeVariant(pick, pick.getAttribute('data-variant-id'));
  }

  function syncFromForm(ctx) {
    var idInput = formInput(ctx.pillRow);
    var v = idInput && ctx.byId[idInput.value];
    if (!v) return false;
    var pillVal = ctx.pillAxis === 1 ? v.option1 : v.option2;
    var cardVal = ctx.pillAxis === 1 ? v.option2 : v.option1;
    applyPill(ctx, pillVal, false);
    var card = ctx.group.querySelector('[data-drl-offer][data-variant-id="' + v.id + '"]');
    if (!card) {
      card = [].filter.call(ctx.group.querySelectorAll('[data-drl-offer][data-card-option-value]'),
        function (c) { return c.dataset.cardOptionValue === cardVal; })[0];
    }
    if (card) markSelected(ctx.group, card);
    return true;
  }

  function initPillRow(root) {
    (root || document).querySelectorAll('.drl-offers__pills').forEach(function (pillRow) {
      if (pillRow.dataset.drlPillBound) return;

      var group = groupFor(pillRow);
      if (!group) return;
      var scope = pillRow.closest('[data-drl-offers-scope]') || document;
      var dataEl = scope.querySelector('[data-drl-variant-data]') ||
                   document.querySelector('[data-drl-variant-data]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      pillRow.dataset.drlPillBound = '1';
      group.dataset.drlMultiBound = '1';

      var ctx = {
        pillRow: pillRow,
        group: group,
        variants: variants,
        byId: {},
        pillAxis: parseInt(pillRow.dataset.drlPillAxis, 10) || 1,
        savingsFmt: pillRow.dataset.drlSavingsFmt || 'Spórolj {savings}'
      };
      variants.forEach(function (v) { ctx.byId[v.id] = v; });

      pillRow.querySelectorAll('.drl-offer-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          applyPill(ctx, pill.dataset.drlPillValue, true);
        });
      });

      // Visszairány: a tapadó sáv lapja és a Dawn választója ugyanarra az
      // inputra ír. Nélküle a pirula hazudna, és a következő kártyakattintás
      // visszaírná a régi méretet.
      var idInput = formInput(pillRow);
      if (idInput) idInput.addEventListener('change', function () { syncFromForm(ctx); });

      // Induláskor az input az erősebb: ?variant= a hirdetésből ide érkezik.
      if (!syncFromForm(ctx)) {
        var pre = pillRow.querySelector('.drl-offer-pill--active') || pillRow.querySelector('.drl-offer-pill');
        if (pre) applyPill(ctx, pre.dataset.drlPillValue, true);
      }
    });
  }

  // Egytengelyű csoport: a kijelölt kártya viszi az inputot. A kéttengelyűt
  // a pirulasor szinkronizálta már, azt itt nem írjuk felül.
  function initSingleSync(root) {
    (root || document).querySelectorAll('[data-drl-offers]').forEach(function (group) {
      if (group.dataset.drlMultiBound) return;
      var sel = group.querySelector('.drl-offer--selected[data-variant-id]');
      if (sel) selectOffer(sel);
    });
  }

  function initAll(root) {
    initOffers(root);
    initPillRow(root);
    initSingleSync(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-bind after Shopify re-renders the block.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) { initAll(e.target); });
})();
